import { opaccAjaxPlugin } from '../opacc.static.js';
import { autocompleteMessages } from '../messages/opacc.messages.js';

/** @module form */

/**
 * PLZ / Ort & Land abfrage
 * @param {HTMLElement} form Formular, welches für die PLZ / Ort Abfrage benötigt wird
 */
export class OpaccZipSearch {
	constructor(form) {
		this.form = form;
		this.formFieldSelector = '.opc-form-field';

		this.inputFields = [];
		this.inputFieldList = form.querySelectorAll('[data-op-zipcity-search]');

		// diese keys werden beim keyUp ignoriert
		this.ignoredKeys = [
			9, // tab
			13, // enter
			16, // shift
			17, // ctrl
			18, // alt
			19, // pause
			20, // caps
			27, // escape
			33, // page up
			34, // page down
			35, // end
			36, // home
			37, // left
			38, // up
			39, // right
			40 // down
		];

		if (this.inputFieldList.length > 0) {
			// eslint-disable-next-line no-unused-vars
			Array.from(this.inputFieldList).forEach((item, index) => {
				let fieldWrapper = item.closest(this.formFieldSelector);
				this.inputFields.push({
					inputField: item,
					dropdown: fieldWrapper.querySelector('[data-op-zipcity-list]'),
					country: this.form.querySelector(`#${item.dataset.opCountryId}`),
					isDirty: false,
					data: []
				});
			});
		}

		if(this.inputFields.length > 0){
			this.attachEventListener();
		}

		this.eventDispatcher = null;
		this.lastSearchTerm = null;
	}

	/**
	 * Split PLZ & Ort
	 *
	 * @param {HTMLElement} value Value des Eingabefeldes
	 * @returns {Object} PLZ und Ort als Objekt
	 */
	parseZipCity(value){

		let zip = undefined;
		let arr = value.split(' ');
		let nbrRegex = new RegExp('^[0-9]+$');
		zip = arr.find(elem => {
			if (nbrRegex.test(elem)) {
				return elem;
			}
		});

		if(!zip){
			let arr = value.split(' ');
			if(arr.length > 1){
				zip = parseInt(arr[1]);
			}

			if(!zip){
				zip = '';
			}
		}

		let city = value.replace(zip, '').trim();
		if(city === 'undefined'){
			city = '';
		}

		return {
			zip: zip,
			city: city
		};
	}

	/**
	 * Event Registrierungen im DOM
	 *
	 */
	attachEventListener(){
		let liSelected = undefined;
		Array.from(this.inputFields).forEach(item => {

			item.inputField.addEventListener('click', () => {
				if(item.dropdown.hasChildNodes()){
					item.dropdown.parentNode.classList.toggle('is-visible');
				}
			});

			item.inputField.addEventListener('keydown', e => {
				if(e.keyCode == 9 || e.keyCode == 13 || e.keyCode == 40){
					liSelected = item.dropdown.firstChild;
					if(liSelected){
						item.dropdown.parentNode.classList.add('is-visible');
						liSelected.focus();
						e.preventDefault();
					}
				}
			});

			item.inputField.addEventListener('keyup', e => {
				if(e.keyCode == 9 || e.keyCode == 13 || e.keyCode == 40){
					return;
				}

				if(this.ignoredKeys.indexOf(e.keyCode) >= 0){
					return;
				}

				this.searchZip(e.target.value, item);
			});

			item.dropdown.addEventListener('keydown', e => {
				if(e.which === 40){
					if(liSelected){
						let next = liSelected.nextSibling;
						liSelected = next !== undefined && next !== null ? next : liSelected;
					}
					else{
						liSelected = item.dropdown.firstChild;
					}

					liSelected.focus();
					this.setScroller(liSelected, item);
					e.preventDefault();
				}
				else if(e.which === 38){
					if(liSelected){
						var next = liSelected.previousSibling;
						liSelected = next !== undefined && next !== null ? next : liSelected;
					}
					else{
						liSelected = item.dropdown.firstChild;
					}

					liSelected.focus();
					this.setScroller(liSelected, item);
					e.preventDefault();
				}
				else if(e.which === 13){
					this.selectItem(item, liSelected.innerText, liSelected.dataset.opCountry);
					e.preventDefault();
				}
				else if(e.which === 9){
					item.dropdown.parentNode.classList.remove('is-visible');
				}
			});

			item.dropdown.addEventListener('click', e => {
				this.selectItem(item, e.target.innerText, e.target.dataset.opCountry);
			});

			if (item.country !== null && item.country != '') {
				item.country.addEventListener('change', e => {
					if(item.data.length === 0 || item.data.country != e.target.value){
						this.clearData(item);
						item.inputField.value = '';
					}
				});
			}
		});
	}

	/**
	 *
	 *
	 * @param {*} item
	 * @param {*} value
	 * @param {*} country
	 */
	selectItem(item, value, country){
		item.inputField.value = value;
		if (item.country !== null) {
			item.country.value = (country) ? country : '';
		}

		var zipCity = this.parseZipCity(value);
		item.data = [];
		item.data.push({ zip:zipCity.zip, city: zipCity.city, country: country });

		item.isDirty = false;
		item.inputField.focus();
		item.dropdown.parentNode.classList.remove('is-visible');
	}

	/**
	 *
	 *
	 * @param {*} el
	 * @param {*} item
	 */
	setScroller(el, item){
		let index = Array.prototype.slice.call(item.dropdown.children).indexOf(el);
		let elHeight = el.height;
		let scrollTop = item.dropdown.parentNode.scrollTop;
		let viewport = scrollTop + item.dropdown.parentNode.height;
		let elOffset = elHeight * index;

		if (elOffset < scrollTop || (elOffset + elHeight) > viewport)
		{
			item.dropdown.parentNode.scrollTop = elOffset;
		}
	}

	/**
	 *
	 *
	 * @param {*} value
	 * @param {*} item
	 * @returns {*}
	 */
	searchZip(value, item){
		if(value === undefined || value === null){
			return;
		}

		value = value.trim();

		if(value.length < 2){
			this.clearData(item);
			return;
		}

		this.lastSearchTerm = value;
		if(this.eventDispatcher) {
			clearTimeout(this.eventDispatcher);
		}
		this.eventDispatcher = setTimeout(()=> { this.callApi(value, item); }, 300);
	}

	/**
	 *
	 *
	 * @param {*} value
	 * @param {*} item
	 * @returns {*}
	 */
	callApi(value, item){
		if(this.lastSearchTerm !== value){
			return;
		}

		let country = 'ch';
		if(item.country !== null && item.country.value !== '' ) {
			country = item.country.value.toLowerCase();
		}
		let zipCity = this.parseZipCity(value);
		let fetchUrl = `/api/portal/v1/zipsearch?zip=${zipCity.zip}&city=${zipCity.city}&country=${country}`;
		opaccAjaxPlugin.fetchAsynGetJson(fetchUrl, this.refreshResultList.bind(this, item) );
	}

	/**
	 *
	 *
	 * @param {*} item
	 * @param {*} asyncData
	 * @returns {*}
	 */
	refreshResultList(item, asyncData){
		if(!asyncData){
			return;
		}

		this.clearData(item);

		asyncData.forEach(element => {
			let li = document.createElement('li');
			li.dataset.opCountry = element.country;
			li.dataset.opZip = element.zip;
			li.dataset.opCity = element.city;
			li.appendChild(document.createTextNode(`${element.zip} ${element.city}`));
			li.tabIndex = -1;
			item.dropdown.appendChild(li);

			item.data.push({ zip:element.zip, city: element.city, country: element.country });
		});

		if (item.data.length === 0) {
			let li = document.createElement('li');
			li.appendChild(document.createTextNode(autocompleteMessages.messageNoValueFound.text));
			li.classList.add('disabled');
			item.dropdown.appendChild(li);
		}
		item.isDirty = true;
		item.dropdown.parentNode.classList.add('is-visible');
	}

	/**
	 *
	 *
	 * @param {*} item
	 */
	clearData(item){
		while (item.dropdown.firstChild) {
			item.dropdown.removeChild(item.dropdown.firstChild);
		}

		item.data = [];
	}
}